import axios from 'axios';
import Loader from 'react-loader-spinner';
import React, { useState, useEffect } from 'react';

import './style.css';

const Publications = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(false);

  const baseUrl = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    axios
      .get(`${baseUrl}/report`)
      .then((res) => {
        setLoading(false);
        setReports(res.data.data.docs || []);
      })
      .catch((err) => {
        setLoading(false);
        setLoadingError(true);
      });
  }, [baseUrl]);

  return (
    <div className="wpo-about-area section-padding">
      <div className="container">
        <div className="row">
          {loading ? (
            <div className="result-container">
              <Loader type="Oval" color="#d90404" height={80} width={80} />
            </div>
          ) : loadingError ? (
            <div className="result-container">
              <p>Could not fetch publications. Refresh or check back later.</p>
            </div>
          ) : !reports.length ? (
            <div className="result-container">
              <p>No publications. Check back later.</p>
            </div>
          ) : (
            <div className="col-lg-12 col-md-12 colsm-12">
              <div className="wpo-about-text">
                <h2 className="pb-4">Publications</h2>
                <p>Official downloadable publications in form of documents.</p>
                <div className="row">
                  {reports.map((report) => (
                    <div
                      key={report._id}
                      className="col-lg-6 col-md-12 col-sm-12 col-12"
                    >
                      <div className="info-item">
                        <h2>{report.title}</h2>
                        <div className="info-wrap">
                          <div className="info-text">
                            <p>{report.description}</p>
                          </div>
                          <a
                            href={report.file}
                            className="theme-btn-s2"
                            target={'_blank'}
                            rel="noopener noreferrer"
                          >
                            Download
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Publications;
